 
/* eslint-disable no-case-declarations */
import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild, inject } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { of, Observable, NEVER } from "rxjs";
import { finalize, map, switchMap, tap } from "rxjs/operators";
import { CstDialogResult } from "src/app/common-components/dialogs/cst-dialog-enums";
import { CstDialogsService } from "src/app/common-components/dialogs/cst-dialogs.service";
import { IFormDropDownItem } from "src/app/common-components/form-controls/form-dropdown/dropdown.component";
import {
  CstListViewDataSource,
  ICstGuiCommand,
  ICstListViewColumn,
  ICstListViewState,
} from "src/app/common-components/list-view/models";
import { CstResponsivePopupService } from "src/app/common-components/resp-popup/services/resp-popup.service";
import { Claims } from "src/app/constants";
import { CstConnectionService } from "src/app/services/cst-connection.service";
import { UserService } from "src/app/services/user.service";
import { WawiApiNoteFacilityCreateDialogComponent } from "src/app/wawi-api/notes/note-facility/create/note-facility-create-dialog.component";
import { WawiApiNoteFacilityExtendedFilterComponent } from "src/app/wawi-api/notes/note-facility/extended-filter/note-facility-extended-filter.component";
import { WawiApiNoteFacilityExtendedFilterModel } from "src/app/wawi-api/notes/note-facility/extended-filter/note-facility-extended-filter.model";
import { WawiApiNoteFacilityUpdateDialogComponent } from "src/app/wawi-api/notes/note-facility/update/note-facility-update-dialog.component";
import {
  NoteAcknowledged,
  NoteDisplayLevelMobile,
  NoteFacilityDeleteCommand,
  NoteFacilityDetailDto,
  NoteFacilityLookupDto,
  NotesClientProvider,
  NotesFacilitySyncCommand,
  NoteDisplayLevel
} from "src/app/web-api/web-api";

enum DLG_TYPES {
  "noteFacilityCreate",
  "noteFacilityUpdate",
}

@Component({
    selector: "app-infoportal-notes-facility-overview",
    templateUrl: "./notes-facility.component.html",
    styleUrls: ["./notes-facility.component.scss"],
    standalone: false
})
export class InfoportalNotesFacilityOverviewComponent
  implements OnInit, AfterViewInit
{
  private _client = inject(NotesClientProvider);
  private _dlg = inject(CstDialogsService);
  private _route = inject(ActivatedRoute);
  private _router = inject(Router);
  private _popup = inject(CstResponsivePopupService);
  private _userService = inject(UserService);
  private _connectionService = inject(CstConnectionService);
  private _fb = inject(FormBuilder);
  dialog = inject(MatDialog);

  NOTE_DISPLAY_LEVEL_MOBILE = NoteDisplayLevelMobile;
  NOTE_ACK = NoteAcknowledged;
  NOTE_DISPLAY_LEVEL = NoteDisplayLevel;

  private _facilityNoInternal = "";
  @Input() public set facilityNoInternal(value: string) {
    this._facilityNoInternal = value;
    this.OnNotesRefresh();
  }
  public get facilityNoInternal() {
    return this._facilityNoInternal;
  }

  @Output() noteFacilityCreated = new EventEmitter<NoteFacilityDetailDto>();
  @Output() noteFacilityUpdated = new EventEmitter<NoteFacilityLookupDto>();
  @Output() noteFacilityDeleted = new EventEmitter<number>();

  private _showPagination = false;
  @Input() set showPagination(value: boolean){
    this._showPagination = value;
    if(this.dataSource?.state){
    this.dataSource.setPagination( value ? {pageSize: 10} : null);} 
  }
  get showPagination() {
    return this._showPagination;
  }

  @ViewChild("colInfos") public tempRefColInfos: TemplateRef<any>;
  private _colInfos: ICstListViewColumn<NoteFacilityLookupDto> = null;

  public selectedNoteDisplayLevelFilter:any;
  public entryTypeFilterForm: FormGroup;
  private showAllEntryTypesFilter = 999;

  public entryTypeFilters: Array<IFormDropDownItem> = [
    { 
      label: $localize`:@@selectedNoteDisplayLevelFilter_undefined:Alle anzeigen`,
      value: this.showAllEntryTypesFilter, 
    },
    { 
      label: $localize`:@@NoteDisplayLevel_Standard:Standard`,
      value: NoteDisplayLevel.Standard,
    },
    { 
      label: $localize`:@@NoteDisplayLevel_Hervorgehoben:Hervorgehoben`,
      value: NoteDisplayLevel.Hervorgehoben,
    },
    { 
      label: $localize`:@@NoteDisplayLevel_AktivAnzeigen:Aktiv anzeigen`,
      value: NoteDisplayLevel.AktivAnzeigen,
    },
  ];

  public serviceDisplayLevelFilter = new WawiApiNoteFacilityExtendedFilterModel(); 
  public filtersCombined = [];
  public filteredDataSource: CstListViewDataSource<NoteFacilityLookupDto> = null;
  public isLoading = false;
  public dataSource: CstListViewDataSource<NoteFacilityLookupDto> = null;
  public columns: ICstListViewColumn<NoteFacilityLookupDto>[] = null;
  public status = "ONLINE";
  public isConnected = true;

  public rowActions: ICstGuiCommand[] = [
    {
      icon: "edit",
      label: $localize`:@@InfoPortal_ElevatorsDetail_FacilityNotes_RowAction_Update_Label:Update`,
      tooltip: (_) =>
        $localize`:@@InfoPortal_ElevatorsDetail_FacilityNotes_Update_Tooltip:Update the Facilitynote`,
      canExecute: (item) => item,
      execute: (item) => {
        this._handleDialogToDisplay(DLG_TYPES.noteFacilityUpdate, item, item.id);
      },
    },
    {
      icon: "delete",
      label: $localize`:@@InfoPortal_ElevatorsDetail_FacilityNotes_RowAction_Delete_Label:Delete`,
      tooltip: (_) =>
        $localize`:@@InfoPortal_ElevatorsDetail_FacilityNotes_Delete_Tooltip:Delete the Facilitynote`,
      canExecute: this._canFacilityNoteDelete.bind(this),
      execute: this._onFacilityNoteDelete.bind(this),
    },
  ];

  public constructor() {
    this._connectionService.monitor().subscribe((isConnected) => {
      this.isConnected = isConnected.hasInternetAccess;
      if (this.isConnected) {
        this.status = "ONLINE";
        if (this.facilityNoInternal && this.dataSource.count === 0) {
          this.OnNotesRefresh();
        }
      } else {
        this.status = "OFFLINE";
      }
    });
    this._colInfos = {
      header: null,
      field: "displayLevelMobile",
      width: "120px",
    };
    this.columns = [
      this._colInfos,
      {
        header: $localize`:@@Infoportal_ElevatorDetail_NotesFacilityOverview_Header_InsertedAt:Inserted`,
        field: "insertedDateTime",
        serverSortField: "Timestamp",
        format: "date",
        width: "110px",
      },
      {
        header: $localize`:@@Infoportal_ElevatorDetail_NotesFacilityOverview_Header_InsertedBy:User`,
        field: "insertedBy",
        serverSortField: "InsertedUser",
        width: "80px",
      },
      {
        header: $localize`:@@Infoportal_ElevatorDetail_NotesFacilityOverview_Header_Note:Note`,
        field: "note",
        serverSortField: "funktioniertNochNicht",
        width: "100%",
        overflow: "ellipsis",
      },
    ];
    this.dataSource = new CstListViewDataSource({
      pagination: this._showPagination ? {pageSize: 10} : null,
      sorting: {
        column: "insertedDateTime",
        direction: "desc",
        enableServerSideSorting: true,
      },
    });
    this.dataSource.registerFetchDataCallback(this._fetchData.bind(this));
  }

  public get displayFilter() {
    return this.filtersCombined?.length > 0;
  }

  public ngOnInit():void{
    this.entryTypeFilterForm = this._fb.group({
      selectedFilter: [null],
    });
    this.selectedNoteDisplayLevelFilter = 999;
  }

  public onExtendedFiltersClick(): void {
    const dialogRef = this.dialog.open(WawiApiNoteFacilityExtendedFilterComponent, {
      data: this.serviceDisplayLevelFilter,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result !== null && result !== undefined) {
        this.serviceDisplayLevelFilter = result;
        this._refreshFiltersCombined();
        this.onSearchClick();
      }
    });
  }

  private _refreshFiltersCombined() {
    const result = [];
    if ( this.serviceDisplayLevelFilter && 
      this.serviceDisplayLevelFilter.eventFilter !== 
        this.selectedNoteDisplayLevelFilter
    ) {
      const label = this.entryTypeFilters.find(
        (x) => x.value === this.serviceDisplayLevelFilter.eventFilter
      )?.label;
      if (label) {
        result.push({
          label,
          onRemove: (_) => {
            this.serviceDisplayLevelFilter.eventFilter = null; 
            this.selectedNoteDisplayLevelFilter = undefined; 
            this._refreshFiltersCombined();
            this.OnNotesRefresh();
          },
        });
      }
    }
    this.filtersCombined = result;
  }

  public onSearchClick(): void {
    if (
        this.serviceDisplayLevelFilter.eventFilter === null || 
        this.serviceDisplayLevelFilter.eventFilter === undefined
      ) 
    {
      this.serviceDisplayLevelFilter.eventFilter = this.showAllEntryTypesFilter;
    }
    this.fillFilteredNote(this.serviceDisplayLevelFilter.eventFilter);
  }

  public fillFilteredNote(_e: NoteDisplayLevel): void{
    if (!this.isConnected || !this._facilityNoInternal) {
      return;
    }
    this.selectedNoteDisplayLevelFilter = this.serviceDisplayLevelFilter.eventFilter;
    this.OnNotesRefresh();
  }

  public OnNotesRefresh(){
    if (!this.isConnected) {
      return;
    }
    if (!this.facilityNoInternal) {
      return;
    }
    this.dataSource.refresh();
  }

  private _fetchData(state: ICstListViewState){
    if (!this.isConnected) {
      return;
    }
    return this._client.notesFacilityGetList(
      this.facilityNoInternal,
      undefined,
      undefined,
      undefined,
      [this.selectedNoteDisplayLevelFilter],
      state.pagination?.offset,
      state.pagination?.pageSize,
      state.sorting ? `${state.sorting.column} ${state.sorting.direction}`:null
    ).pipe(
      map((result)=> {
        return{
          data: result.data,
          total: result.total,
        };
      })
    );
  }

  public ngAfterViewInit() {
    this._colInfos.template = this.tempRefColInfos;
    this._route.queryParams.subscribe((params) => {
      if (params.dialog && typeof params.dialog === "string") {
        this._handleDialogToDisplay(DLG_TYPES[params.dialog], null, params);
      }
    });
  }

  public get isNoteFacilityCreateVisible() {
    return this._userService.CurrentUser.internalAccess;
  }

  public OnNoteFacilityCreate() {
    if (!this.isConnected) {
      return;
    }
    this._RequestDialogToDisplay(DLG_TYPES.noteFacilityCreate);
  }

  private _FacilityNoteUpdateDisplay(noteID: number) {
    if (!this.isConnected) {
      return;
    }
    if (!this.isNoteFacilityCreateVisible || !this.facilityNoInternal) {
      return of(null);
    }
    const popRef = this._popup.open(WawiApiNoteFacilityUpdateDialogComponent, {
      data: { noteID },
    });
    return popRef.afterClosed().pipe(
      tap((result: NoteFacilityDetailDto) => {
        if (!result) {
          return;
        }
        this.dataSource.refresh();
        this.noteFacilityUpdated.emit(result);
      })
    );
  }

  private _FacilityNoteCreateDisplay() {
    if (!this.isConnected) {
      return;
    }
    if (!this.isNoteFacilityCreateVisible || !this.facilityNoInternal) {
      return of(null);
    }
    const popRef = this._popup.open(WawiApiNoteFacilityCreateDialogComponent, {
      data: { facilityNoInternal: this.facilityNoInternal },
    });
    return popRef.afterClosed().pipe(
      tap((result: NoteFacilityDetailDto) => {
        if (!result) {
          return;
         
        }
        this.dataSource.refresh();
        this.noteFacilityCreated.emit(result);
      })
    );
  }

  private _RequestDialogToDisplay(dialogType: DLG_TYPES, params?: any) {
    console.log("bam");
    
    if (!this.isConnected) {
      console.log("not connected?");
      return;
    }
    this._router.navigate(["."], {
      relativeTo: this._route,
      queryParams: {
        dialog: dialogType !== null ? DLG_TYPES[dialogType] : null,
        ...params,
      },
      queryParamsHandling: "merge",
      replaceUrl: true,
    });
  }

  private _canFacilityNoteDelete(item: NoteFacilityLookupDto) {
    
    return item ? true : false;
  }

  public get hasRoleSystemverwalter() {
    return this._userService.HasClaim(Claims.Benutzerverwaltung_BenutzerDelete && Claims.Benutzerverwaltung_BenutzerUpdate);
  }

  private _onFacilityNoteDelete(item: NoteFacilityLookupDto) {
    if (!this._canFacilityNoteDelete(item)) {
      return;
    }
    const userCriteriaMatches = this._userService.CurrentUser.username == item.insertedBy;
      if(!userCriteriaMatches)
      {
        if(!this.hasRoleSystemverwalter){
          this._dlg.Information($localize`:@@InfoPortal_ElevatorsDetail_FacilityNotes_Delete_Information:Notes may only be deleted by the author or by authorised persons!`);
          return;
        }
      }
    this._dlg
      .AskYesCancel(
        $localize`:@@InfoPortal_ElevatorsDetail_FacilityNotes_Delete_Confirmation:Do you really want to delete this facility note?`
      )
      .pipe(
        switchMap((dlgResult) => {
          if (dlgResult !== CstDialogResult.Yes) {
            return NEVER;
          }
          this.dataSource.loading$.next(true);
          const syncCmd = new NotesFacilitySyncCommand({
            deleteCommands: [new NoteFacilityDeleteCommand({ id: item.id })],
          });
          return this._client.notesFacilitySync(syncCmd);
        }),
        finalize(() => this.dataSource.loading$.next(false))
      )
      .subscribe(() => {this.dataSource.refresh();
        this.noteFacilityDeleted.emit(item.id);
      });
  }

  private _handleDialogToDisplay(dialogType: DLG_TYPES, item?: NoteFacilityLookupDto, params?: any) {
    if (!this.isConnected) {
      return;
    }
    let obs: Observable<any> = null;
    switch (dialogType) {
      case DLG_TYPES.noteFacilityCreate:
        obs = this._FacilityNoteCreateDisplay();
        break;
      case DLG_TYPES.noteFacilityUpdate:
        const userCriteriaMatches = this._userService.CurrentUser.username == item.insertedBy;
        if(!userCriteriaMatches)
        {
          if(!this.hasRoleSystemverwalter){
            this._dlg.Information($localize`:@@InfoPortal_ElevatorsDetail_FacilityNotes_Change_Information:Notes may only be changed by the author or authorised persons!`);
            return;
          }
        }
        obs = this._FacilityNoteUpdateDisplay(params);
        break;
    }
    if (!obs) {
      return;
    }
    obs.subscribe(() => {
      this._RequestDialogToDisplay(null);
    });
  }

}